import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as paymentService from "../../services/payment.services";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Breadcrums from "../../common/breadcrumbs";
import {
  capitalizeFirstLetter,
  formateDateWithMonth,
  formateDateWithMonthAdmin,
  handleServerValidations,
  TrimText,
} from "../../../../utils/commonfunction";
import CustomRangepicker from "../../common/rangepicker";
import StatusFilter from "../../common/statusFilter";
import { Tooltip, Whisper, Placeholder, Modal } from "rsuite";
import * as $ from "jquery";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
import { INDIAN_STATES, SWAL_SETTINGS } from "../../../../utils/Constants";

const PaymentList = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);

  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [resetdate, setResetDate] = useState(false);
  const [searchParams] = useSearchParams();

  // Excel Export State
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportMonth, setExportMonth] = useState(moment().month() + 1);
  const [exportYear, setExportYear] = useState(moment().year());
  const [exportType, setExportType] = useState("month"); // "month" or "custom"
  const [customStartDate, setCustomStartDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [customEndDate, setCustomEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [exportStatus, setExportStatus] = useState("all");
  const [exportState, setExportState] = useState("all");
  const [exporting, setExporting] = useState(false);
  const [downloadingInvoiceId, setDownloadingInvoiceId] = useState(null);

  // const [search] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({
    ...(searchParams.get("status")
      ? { payment_status: searchParams.get("status") }
      : {}),
  });
  console.log(search, 222);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("Transactions"), url: "" },
  ];
  const showInquiryFilterList = [
    { name: "list_heading_status", status__id: "" },
    { name: "Completed", status__id: "completed" },
    { name: "Pending", status__id: "pending" },
    { name: "Failed", status__id: "failed" },
    { name: "Refunded", status__id: "refunded" },
  ];

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        paymentService
          .List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            // setSerialNo(data.data.offset);
            setList(
              data && data.data && data.data.list ? data?.data?.list : [],
            );
            // console.log("data.data.=====>", data.data);

            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);
    return () => clearTimeout(getData);
  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
  ]);

  const viewfunction = (row) => {
    navigate(`/admin/payment/view/${row._id}`);
  };

  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function

  const prepareSearch = (key, value) => {
    console.log("key---", key, value);
    const statusLabelMap = {
      completed: "completed",
      pending: "pending",
      failed: "failed",
    };

    let sr;

    if (statusLabelMap[value]) {
      sr = { payment_status: statusLabelMap[value] };
    } else {
      sr = { ...search };
      if (String(value).length > 0) {
        sr[key] = value;
      } else {
        delete sr[key];
      }
    }

    if (
      value &&
      typeof value === "string" &&
      value.toLowerCase() === "status"
    ) {
      sr = {};
    }

    console.log("sr---", sr);
    setSearch(sr);
  };
  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    const lower = string.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  };
  // search or filer end

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
  };

  const handleExportExcel = async () => {
    try {
      setExporting(true);
      const payload = {};
      if (exportType === "month") {
        payload.month = exportMonth;
        payload.year = exportYear;
      } else {
        if (!customStartDate || !customEndDate) {
          setExporting(false);
          Swal.fire({
            icon: "warning",
            text: "Please select both Start Date and End Date.",
          });
          return;
        }
        payload.start_date = customStartDate;
        payload.end_date = customEndDate;
      }
      if (exportStatus && exportStatus !== "all" && exportStatus !== "status") {
        payload.payment_status = exportStatus;
      }
      if (exportState && exportState !== "all" && exportState !== "state") {
        payload.state = exportState;
      }

      const res = await paymentService.ExportExcel(payload);
      setExporting(false);
      if (res?.success && res?.data?.base64) {
        const byteCharacters = atob(res.data.base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = res.data.fileName || `Transactions_Export.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setShowExportModal(false);
        Swal.fire({
          icon: "success",
          title: "Export Successful",
          text: `Excel report generated successfully (${res.data.totalRecords || 0} records).`,
          timer: 2500,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: "error",
          text: res?.message || "Failed to generate Excel export",
        });
      }
    } catch (err) {
      setExporting(false);
      console.error("Export error:", err);
      Swal.fire({
        icon: "error",
        text: err?.message || "Error generating Excel export",
      });
    }
  };

  const handleDownloadInvoice = async (row) => {
    try {
      setDownloadingInvoiceId(row._id);
      const res = await paymentService.DownloadInvoice(row._id);
      setDownloadingInvoiceId(null);
      if (res?.success && res?.data?.base64) {
        const byteCharacters = atob(res.data.base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: "application/pdf",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = res.data.fileName || `Invoice_${row._id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
        Swal.fire({
          icon: "success",
          title: "Invoice Downloaded",
          text: `Invoice ${res.data.invoice_number || ""} downloaded successfully.`,
          timer: 2200,
          showConfirmButton: false,
        });
      } else if (res?.data?.invoice_url) {
        window.open(res.data.invoice_url, "_blank");
      } else {
        Swal.fire({
          icon: "error",
          text: res?.message || "Failed to download invoice",
        });
      }
    } catch (err) {
      setDownloadingInvoiceId(null);
      console.error("Download invoice error:", err);
      Swal.fire({
        icon: "error",
        text: err?.message || "Error downloading invoice",
      });
    }
  };

  const Deletefunction = (data) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes_delete"),
    }).then((result) => {
      if (result.isConfirmed) {
        paymentService
          .Delete({ _id: data?._id || data })
          .then((response) => {
            setStatusUpdate((prev) => !prev);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError", error);
          });
      }
    });
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
              <h6 className="main-content-label mb-0">
                {t("Transactions")}
              </h6>
              <div className="d-flex align-items-center flex-wrap gap-2">
                <div className="form-group mb-0 me-2">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-2">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-2">
                  <StatusFilter
                    data={showInquiryFilterList}
                    prepareSearch={prepareSearch}
                    selectedStatus={search?.payment_status || ""}
                  />
                </div>

                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning me-2"
                >
                  {t("btn_reset_filter")}
                </button>

                <button
                  type="button"
                  onClick={() => setShowExportModal(true)}
                  className="btn btn-success d-flex align-items-center"
                  title="Export Monthly Transactions Excel"
                >
                  <i className="fa fa-file-excel-o me-1"></i>
                  <span>Export Monthly Excel</span>
                </button>
              </div>
            </div>
            {loader ? (
              <Placeholder.Paragraph
                className="w-100"
                rowHeight={30}
                rowSpacing={5}
                active={true}
                rows={7}
              />
            ) : (
              <>
                <div className="table-responsive min-h-400">
                  <table className="table table-bordered border-t0 table table-bordered card-table border-top text-nowrap w-100 text-nowrap w-100">
                    <thead>
                      <tr>
                        <th className="position-relative select_head">
                          <span>{t("list_heading_sno")}</span>
                        </th>

                        <th>
                          <div className="sorting_column">
                            <span>{t("list_heading_invoice_no", "Invoice Number")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="invoice_number"
                            />
                          </div>
                        </th>

                        {/* <th className="status_head">{t("list_heading_status")}</th> */}
                        <th>
                          <div className="sorting_column">
                            <span>{t("list_heading_name")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="name"
                            />
                          </div>
                        </th>

                        <th>
                          <div className="sorting_column">
                            <span>{t("label_email")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="email"
                            />
                          </div>
                        </th>

                        <th>
                          <div className="sorting_column">
                            <span>{t("label_state", "State")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="state"
                            />
                          </div>
                        </th>

                        <th>
                          <div className="rating_head">
                            <span>payment method</span>
                          </div>
                        </th>

                        <th>
                          <div className="rating_head">
                            <span>{t("list_heading_status")}</span>
                          </div>
                        </th>

                        <th>
                          <div className="rating_head">
                            <span>Amount(INR)</span>
                          </div>
                        </th>

                        {/* <th className="status_head">SUBSCRIBE</th> */}
                        <th className="created_head">
                          <div className="sorting_column">
                            <span>{t("label_payment_date")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              defaultSorting={defaultSorting}
                              column="createdAt"
                            />
                          </div>
                        </th>

                        <th className="action_head">
                          {t("list_heading_action")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {list.length ? (
                          list.map((row, i) => {
                            return (
                              <tr key={i}>
                                <td>
                                  {row
                                    ? (page - 1) * itemperpage + i + 1
                                    : null}
                                </td>

                                <td>
                                  <div className="d-flex font-weight-semibold">
                                    {row?.invoice_number && row.invoice_number !== "N/A"
                                      ? row.invoice_number
                                      : "N/A"}
                                  </div>
                                </td>

                                <td>
                                  {row?.name ? (
                                    <div className="d-flex">
                                      {row?.name
                                        ? capitalizeFirstLetter(
                                            TrimText(row.name, 50),
                                          )
                                        : "N/A"}
                                    </div>
                                  ) : (
                                    <div className="d-flex">"N/A"</div>
                                  )}
                                </td>

                                <td>
                                  {row?.email ? (
                                    <div className="d-flex">
                                      {TrimText(row.email, 50)}
                                    </div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>

                                <td>
                                  <div className="d-flex">
                                    {row?.state || row?.store_location?.state || "N/A"}
                                  </div>
                                </td>

                                <td>
                                  {row?.payment_method ? (
                                    <div className="d-flex">
                                      {row.payment_method.toLowerCase() ===
                                      "upi"
                                        ? "UPI"
                                        : capitalizeFirstLetter(
                                            row.payment_method,
                                          )}
                                    </div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>

                                <td>
                                  {row?.payment_status ? (
                                    <div className="d-flex">
                                      {capitalizeFirstLetter(row.payment_status)}
                                    </div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>

                                <td>
                                  {row?.package_price ? (
                                    <div className="d-flex">
                                      {t(row.package_price)}
                                    </div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>

                                <td>
                                  {row.createdAt
                                    ? formateDateWithMonthAdmin(row.createdAt)
                                    : "N/A"}
                                </td>

                                <td>
                                  <div
                                    className="btn-toolbar table-actions"
                                    role="toolbar"
                                    aria-label="Toolbar with button groups"
                                  >
                                    <div
                                      className="btn-group btn-group-sm"
                                      role="group"
                                      aria-label="Second group"
                                    >
                                      <Whisper
                                        placement="top"
                                        controlId="control-id-hover"
                                        trigger="hover"
                                        speaker={
                                          <Tooltip
                                            style={{ fontWeight: "bold" }}
                                          >
                                            View
                                          </Tooltip>
                                        }
                                      >
                                        <button
                                          type="button"
                                          className="btn view"
                                          onClick={() => {
                                            viewfunction(row);
                                          }}
                                        >
                                          <i className="ri-eye-fill"></i>
                                        </button>
                                      </Whisper>

                                      <Whisper
                                        placement="top"
                                        controlId="control-id-hover"
                                        trigger="hover"
                                        speaker={
                                          <Tooltip
                                            style={{ fontWeight: "bold" }}
                                          >
                                            Download Invoice
                                          </Tooltip>
                                        }
                                      >
                                        <button
                                          type="button"
                                          className="btn invoice"
                                          onClick={() => {
                                            handleDownloadInvoice(row);
                                          }}
                                          disabled={downloadingInvoiceId === row._id}
                                          title="Download Invoice"
                                        >
                                          {downloadingInvoiceId === row._id ? (
                                            <span
                                              className="spinner-border spinner-border-sm text-primary"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          ) : (
                                            <i className="fa fa-file-pdf-o text-danger"></i>
                                          )}
                                        </button>
                                      </Whisper>

                                      <Whisper
                                        placement="top"
                                        controlId="control-id-hover"
                                        trigger="hover"
                                        speaker={
                                          <Tooltip
                                            style={{ fontWeight: "bold" }}
                                          >
                                            {t("Delete")}
                                          </Tooltip>
                                        }
                                      >
                                        <button
                                          type="button"
                                          className="btn delete"
                                          onClick={() => {
                                            Deletefunction(row?._id);
                                          }}
                                        >
                                          <i className="ri-delete-bin-6-fill"></i>
                                        </button>
                                      </Whisper>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={10} className="text-center">
                              {t("msg_no_records")}
                            </td>
                          </tr>
                        )}
                      </>
                    </tbody>
                  </table>
                </div>
                <div
                  className=""
                  id="example1_info"
                  role="status"
                  aria-live="polite"
                >
                  <b>
                    {t("msg_total_records")} : {datalength ? datalength : "0"}
                  </b>
                </div>
                {datalength && datalength > 0 ? (
                  <CustomPagination
                    datalength={datalength}
                    itemperpage={itemperpage}
                    currentPage={page}
                    setPage={setPage}
                    pageRoute={[
                      {
                        name: "Reataurant",
                        path: "/admin/payment/list",
                      },
                    ]}
                  />
                ) : (
                  ""
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Monthly / Custom Date Range Excel Export Modal */}
      <Modal open={showExportModal} onClose={() => setShowExportModal(false)} size="sm">
        <Modal.Header>
          <Modal.Title>
            <i className="fa fa-file-excel-o text-success me-2"></i>
            Export Transactions Excel
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="font-weight-semibold mb-2 d-block text-dark">
              Export Mode:
            </label>
            <div className="d-flex w-100 gap-2" style={{ gap: "10px" }}>
              <button
                type="button"
                className={`btn flex-fill py-2 ${exportType === "month" ? "btn-primary shadow-sm" : "btn-outline-primary"}`}
                style={{ fontWeight: 600, borderRadius: "6px" }}
                onClick={() => setExportType("month")}
              >
                <i className="fa fa-calendar me-1"></i> By Month & Year
              </button>
              <button
                type="button"
                className={`btn flex-fill py-2 ${exportType === "custom" ? "btn-primary shadow-sm" : "btn-outline-primary"}`}
                style={{ fontWeight: 600, borderRadius: "6px" }}
                onClick={() => setExportType("custom")}
              >
                <i className="fa fa-calendar-check-o me-1"></i> Custom Date Range
              </button>
            </div>
          </div>

          {exportType === "month" ? (
            <div className="row g-2 mb-3">
              <div className="col-7">
                <label className="font-weight-semibold mb-1 text-dark">Select Month:</label>
                <select
                  className="form-control"
                  value={exportMonth}
                  onChange={(e) => setExportMonth(Number(e.target.value))}
                >
                  <option value={1}>January</option>
                  <option value={2}>February</option>
                  <option value={3}>March</option>
                  <option value={4}>April</option>
                  <option value={5}>May</option>
                  <option value={6}>June</option>
                  <option value={7}>July</option>
                  <option value={8}>August</option>
                  <option value={9}>September</option>
                  <option value={10}>October</option>
                  <option value={11}>November</option>
                  <option value={12}>December</option>
                </select>
              </div>
              <div className="col-5">
                <label className="font-weight-semibold mb-1 text-dark">Select Year:</label>
                <select
                  className="form-control"
                  value={exportYear}
                  onChange={(e) => setExportYear(Number(e.target.value))}
                >
                  {[2024, 2025, 2026, 2027, 2028].map((yr) => (
                    <option key={yr} value={yr}>{yr}</option>
                  ))}
                </select>
              </div>
            </div>
          ) : (
            <div className="row g-2 mb-3">
              <div className="col-6">
                <label className="font-weight-semibold mb-1 text-dark">From Date:</label>
                <input
                  type="date"
                  className="form-control"
                  value={customStartDate}
                  onChange={(e) => setCustomStartDate(e.target.value)}
                />
              </div>
              <div className="col-6">
                <label className="font-weight-semibold mb-1 text-dark">To Date:</label>
                <input
                  type="date"
                  className="form-control"
                  value={customEndDate}
                  onChange={(e) => setCustomEndDate(e.target.value)}
                />
              </div>
            </div>
          )}

          <div className="row g-2 mb-3">
            <div className="col-6">
              <label className="font-weight-semibold mb-1 text-dark">Payment Status:</label>
              <select
                className="form-control"
                value={exportStatus}
                onChange={(e) => setExportStatus(e.target.value)}
              >
                <option value="all">All Statuses</option>
                <option value="completed">Completed</option>
                <option value="pending">Pending</option>
                <option value="failed">Failed</option>
                <option value="refunded">Refunded</option>
              </select>
            </div>
            <div className="col-6">
              <label className="font-weight-semibold mb-1 text-dark">State:</label>
              <select
                className="form-control"
                value={exportState}
                onChange={(e) => setExportState(e.target.value)}
              >
                <option value="all">All States</option>
                {INDIAN_STATES.map((st) => (
                  <option key={st} value={st}>
                    {st}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="p-2 bg-light rounded border small text-muted">
            <i className="fa fa-info-circle text-primary me-1"></i>
            Excel report includes Customer details, GSTIN, HSN Code, Base Price, CGST/SGST tax breakdown, and Total Revenue.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-success me-2"
            onClick={handleExportExcel}
            disabled={exporting}
          >
            {exporting ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                Generating Excel...
              </>
            ) : (
              <>
                <i className="fa fa-download me-1"></i> Download (.xlsx)
              </>
            )}
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowExportModal(false)}
            disabled={exporting}
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PaymentList;
